module.exports = __webpack_public_path__ + "img/students.922c84b1.svg";